import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 获取基本信息
export const getVipActiveInfo = createAsyncThunk(
  'NormalVipActive/getVipActiveInfo',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/aristocracy/reward_vip_prepare', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)
// 激活 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90606241
export const activityVipActive = createAsyncThunk(
  'NormalVipActive/activityVipActive',
  async (p: any = {}, store: any) => {
    const resp = await http.post('/live/aristocracy/reward_vip_active', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data
  }
)

export enum VIP_STATUS {
  notAvailable = 0, // 不可自己激活，可赠送
  readyToActivate = 1, // 待激活
  used = 2, // 已激活
}

export enum VIP_TYPE {
  aristocracy = 1, // 非体验贵族
  aristocracyTrial = 2, // 体验贵族
}

interface AristocracyInfo {
  vip_type: number
  level: number
  name: string
  expire_et: number
  protect_et: number
}

const initialState: {
  status?: VIP_STATUS
  reward_days?: number
  reward_level?: number
  is_vip?: boolean
  text?: string
  current_aristocracy_info?: AristocracyInfo
  active_aristocracy_info?: AristocracyInfo
} = {}

export const NormalVipActiveSlice = createSlice({
  name: 'NormalVipActive',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getVipActiveInfo.fulfilled, (state, action) => {
      const {data} = action.payload
      Object.assign(state, data)
    })
  },
})

export default NormalVipActiveSlice.reducer
